(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["calculator-liner"] && !Shopify.designMode) return;
  try {
    // Add an event listener to the button
  document.getElementById("calculate-liner").addEventListener("click", function() {

    var calculateButton = document.getElementById("button-calculator-liner");
    var resultsButton = document.getElementById("button-calculator-liner-results");
    var resultsDiv = document.getElementById("calculator-results-liner");

    var calculateLength = parseFloat(document.getElementById("CalculatorForm-length-liner").value);
    var calculateWidth = parseFloat(document.getElementById("CalculatorForm-width-liner").value);
    var calculateDepth = parseFloat(document.getElementById("CalculatorForm-depth-liner").value);
    var calculateError = false;

    if (!/^\d+(\.\d+)?$/.test(calculateLength)) {
      var calculateError = true;
    }

    if (!/^\d+(\.\d+)?$/.test(calculateWidth)) {
      var calculateError = true;
    }

    if (!/^\d+(\.\d+)?$/.test(calculateDepth)) {
      var calculateError = true;
    }

    if (calculateError == false) {
      var calculateLinerLength = (calculateLength + (calculateDepth * 2) + 1);
      var calculateLinerWidth = (calculateWidth + (calculateDepth * 2) + 1);
      resultsDiv.innerHTML = "<span>The amount of pond liner you will need is approximately:<strong> " + calculateLinerLength + "m x " + calculateLinerWidth + "m</strong></span>";
      resultsDiv.classList.remove("error");
      setTimeout(()=>{
        resultsDiv.classList.add("show");
        calculateButton.classList.add("hide");
        resultsButton.classList.add("show");
      }, 100);
    } else {
      resultsDiv.innerHTML = "<span>Please enter all pond measurements</span>";
      setTimeout(()=>{
        resultsDiv.classList.add("error");
        resultsDiv.classList.add("show");
      }, 100);
    }

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["calculator-volume"] && !Shopify.designMode) return;
  try {
    // Add an event listener to the button
  document.getElementById("calculate-volume").addEventListener("click", function() {

    var calculateButton = document.getElementById("button-calculator-volume");
    var resultsButton = document.getElementById("button-calculator-volume-results");
    var resultsDiv = document.getElementById("calculator-results-volume");

    var calculateLength = parseFloat(document.getElementById("CalculatorForm-length-volume").value);
    var calculateWidth = parseFloat(document.getElementById("CalculatorForm-width-volume").value);
    var calculateDepth = parseFloat(document.getElementById("CalculatorForm-depth-volume").value);
    var calculateError = false;

    if (!/^\d+(\.\d+)?$/.test(calculateLength)) {
      var calculateError = true;
    }

    if (!/^\d+(\.\d+)?$/.test(calculateWidth)) {
      var calculateError = true;
    }

    if (!/^\d+(\.\d+)?$/.test(calculateDepth)) {
      var calculateError = true;
    }

    if (calculateError == false) {
      var calculateVolume = (calculateLength * calculateWidth * calculateDepth * 1000);
      var calculateVolume = calculateVolume.toLocaleString();
      resultsDiv.innerHTML = "<span>The Pond Volume is approximately:<strong> " + calculateVolume + " Litres</strong></span>";
      resultsDiv.classList.remove("error");
      setTimeout(()=>{
        resultsDiv.classList.add("show");
        calculateButton.classList.add("hide");
        resultsButton.classList.add("show");
      }, 100);
    } else {
      resultsDiv.innerHTML = "<span>Please enter all pond measurements</span>";
      setTimeout(()=>{
        resultsDiv.classList.add("error");
        resultsDiv.classList.add("show");
      }, 100);
    }

  });
  } catch(e) { console.error(e); }
})();

})();
